/**
 * @typedef {Object} ComponentTypeResponseDto
 * @property {number} componentTypeId
 * @property {string} componentTypeName
 * @property {string} componentTypeCode
 * @property {string} [description]
 * @property {boolean} isActive
 * @property {string} createdDate
 * @property {string} [createdBy]
 * @property {string} [modifiedDate]
 * @property {string} [modifiedBy]
 */

/**
 * @typedef {Object} ComponentTypeLookupDto
 * @property {number} componentTypeId
 * @property {string} componentTypeName
 * @property {string} componentTypeCode
 * @property {boolean} isActive
 */

const BASE_PATH = 'v1/ComponentType';

export default function (instance) {
  return {
    /**
     * Get all component types
     * @param {Object} [params]
     * @param {boolean} [params.includeInactive=false]
     * @returns {Promise<{data: ComponentTypeResponseDto[]}>}
     */
    getComponentTypes(params = {}) {
      return instance.get(BASE_PATH, { params });
    },

    /**
     * Get component type by ID
     * @param {number} id
     * @returns {Promise<{data: ComponentTypeResponseDto}>}
     */
    getComponentType(id) {
      return instance.get(`${BASE_PATH}/${id}`);
    },

    /**
     * Get component type by code
     * @param {string} code
     * @returns {Promise<{data: ComponentTypeResponseDto}>}
     */
    getComponentTypeByCode(code) {
      return instance.get(`${BASE_PATH}/by-code/${encodeURIComponent(code)}`);
    },

    /**
     * Get component type lookups for dropdowns
     * @returns {Promise<{data: ComponentTypeLookupDto[]}>}
     */
    getComponentTypeLookups() {
      return instance.get(`${BASE_PATH}/lookups`);
    }
  };
}
